export function getPersistedLanguage() {
  return localStorage.getItem('language')
}

export function persistLanguage(value: string) {
  return localStorage.setItem('language', value)
}
